import { post, get } from '@/utils/request'
import { java_post, java_get } from '@/utils/java_request'

/**
 * 网银转账--上传凭证
 * documentType: 1付款 转账 2是充值 转账
 * @param {Object} data
 * {userToken;''，documentType:'',orderNumber:'',documentImg:''}
 */
export function uploadBankCertificate(data) {
  return post('/miniapps/payment/insertOnlineBanking', data)
}
/**
 * 用户服务消息列表
 * @param {Object} data
 * {userToken:'',currentPageNumber:'',numberOfImpressions:''},
 */
export function getMessageList(data) {
  return post('/miniapps/sysmsg/selectUserSysmsgList', data)
}
/**
 * 用户结算商品详情
 * @param {Object} data
 * {userToken:'',scopeOfUse:'',orderCommodityIds:''},
 */
export function getBalanceGoodsDetail(data) {
  return post('/miniapps/commodity/selectPaymentCommodity', data)
}
/**
 * 用户订单列表
 * @param {Object} data
 * {userToken:'',pageIndex:'',pageSize:''},
 */
export function getOrderList(data) {
  return post('/newOrder/order/list', data)
}
/**
 * 用户订单详情
 * @param {Object} data
 * {userToken:'',soNumber:'',},
 */
export function getOrderDetail(data) {
  return post('/newOrder/order/detail', data)
}
/**
 * 创建订单
 * @param {Object} data
 *
 */
export function createOrder(data) {
  return post('/newOrder/order/create', data)
}
/**
 * 微信支付
 * @param {Object} data
 *
 */
export function payWeChat(data) {
  return post('/unified/payment/WeiXinPayStrengthen', data)
}
/**
 * 支付宝支付
 * @param {Object} data
 *
 */
export function payAli(data) {
  return post('/unified/payment/AliPayStrengthen', data)
}
/**
 * 检测支付
 * @param {Object} data
 *
 */
export function checkPayment(data) {
  return post('/miniapps/payment/checkPaymentResult', data)
}
/**
 * 获取微信地址
 * @param {Object} data
 *
 */
export function getWxUrl(data) {
  return get('/miniapps/wxaccredit/bindingOpenSnsapiBase', data)
}
/**
 * 查询泰康 订单信息
 * @param {Object} data
 *
 */
export function getTkOrder(data) {
  return post('/newOrder/order/taikangLook', data)
}
/**
 * 保存泰康订单信息
 * @param {Object} data
 *
 */
export function saveTkOrder(data) {
  return post('/newOrder/order/taikangSave', data)
}
/**
 * 查询物流
 * @param {Object} data
 *
 */
export function getLogistics(data) {
  return post('/newOrder/order/logistics', data)
}

/**
 * 取消订单
 * @param {Object} data
 *
 */
export function orderCancel(data) {
  return post('/newOrder/order/cancel', data)
}
/**
 * 删除订单
 * @param {Object} data
 *
 */
export function orderDelete(data) {
  return post('/newOrder/order/delete', data)
}
/**
 * 确认收货
 * @param {Object} data
 *
 */
export function orderConfirm(data) {
  return post('/newOrder/order/comfirmdeliver', data)
}
/**
 * 查看拒绝退款原因
 * @param {Object} data
 *
 */
export function orderRefusereson(data) {
  return post('/newOrder/order/refusereson', data)
}

/**
 * 获取自提地址
 * @param {Object} data
 *
 */
export function getMultipleSelfLiftingAddress() {
  return get('/miniapps/addressManagement/selectMultipleSelfLiftingAddress')
}
/**
 * 获取特殊渠道销售支付商品信息
 * @param {Object} data
 *
 */
export function getSalePaymentCommodity(data) {
  return post('/miniapps/commodity/selectSpecialSalePaymentCommodity', data)
}
/**
 * 特殊销售新建订单（立即支付
 * @param {Object} data
 *
 */
export function createSaleOrder(data) {
  return post('/newOrder/order/specialSaleOrderCreate', data)
}
/**
 * 获取订单简要信息
 * @param {Object} data
 *
 */
export function getBriefOrderInfo(data) {
  return post('/newOrder/order/briefOrderInfo', data)
}

/**
 * 获取采购单
 * @param {Object} data
 */
export function getPurchaseOrder(data) {
  return post('/purchase/getPurchaseOrderDetail', data)
}

/**
 * 采购单签约
 * @param {Object} data
 */
export function purchaseSign(data) {
  return post('/purchase/confirmSign', data)
}

/**
 * 采购中心已签约
 * @param {Object} data
 */
export function signContract(data) {
  return java_post('/scmapi/order/signContract', data)
}

/**
 * 采购中心待签约
 * @param {Object} data
 */
export function signContractList(data) {
  return java_post('/scmapi/order/signContractList', data)
}
/**
 * 采购签约-上传物流信息
 * @param {Object} data
 */
export function uploadLogisticsInfo(data) {
  return java_post('/scmapi/order/uploadLogisticsInfo', data)
}

/**
 * 物流公司列表
 * @param {Object} data
 *
 */
export function logisticsList() {
  return java_get('/scmapi/common/logisticsList')
}
